import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";


export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "ankle-patrol.firebaseapp.com",
  projectId: "ankle-patrol",
  storageBucket: "ankle-patrol.appspot.com",
  messagingSenderId: "232466101118",
  appId: "1:232466101118:web:0ddbb12c3f867c631cf92f",
  measurementId: "G-QX3NTRSS90",
};

export const FIREBASE_VAPID_KEY =
  "BHZuMLsflnEy4m_NMIc45yCZkZxgzcaSSvx2TRJbUkwIr69dJEfUYdQX3gSb8W02wbWQVTIrpoHL4-yMTvtVbac";

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const generateToken = async (): Promise<string | null> => {
  const permission = await Notification.requestPermission();
  console.log(permission);
  if (permission === "granted") {
    const token = await getToken(messaging, {
      vapidKey: FIREBASE_VAPID_KEY,
    });
    return token; // Return the token
  }
  return null; // Return null if permission is not granted
};
